/**
 * 布尔取反。
 *
 * @category Logic
 *
 * @public
 *
 * @param value - 输入值
 *
 * @returns 取反后的布尔值。
 */
export function not(value) {
    return !value;
}
//# sourceMappingURL=not.js.map